<div class="card">
  <div class="card-body">
    <div class="row">
      <div class="col-12">
        <div class="row">
          <div class="col-lg-2">
            <div class="form-group">
              <label for="inizio" class="control-label col-form-label">Inizio</label>
              <input id="inizio" required [(ngModel)]="inizio" (ngModelChange)="refresh()" class="form-control"
                     type="date">
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label for="fine" class="control-label col-form-label">Fine</label>
              <input id="fine" required [(ngModel)]="fine" (ngModelChange)="refresh()" class="form-control" type="date">
            </div>
          </div>
          <div class="col-lg-1">
            <div class="form-group">
              <label for="fine" class="control-label col-form-label">Cerca per Data</label>
              <input id="periodo" required [(ngModel)]="periodo" (ngModelChange)="refresh()" class="form-control" type="checkbox">
            </div>
          </div>
          <div class="col-lg-2" *ngIf="permission.isntOperativeRole('U')">
            <div class="form-group">
              <label class="control-label col-form-label">Responsabile</label>
              <ng-multiselect-dropdown required [settings]="utentidropdownSettings" [placeholder]="'Seleziona'"
                                       name="manager"
                                       [data]="managers" [(ngModel)]="managerselezionati"
                                       (onFilterChange)="filtroResponsabile($event)" (ngModelChange)="refresh()">
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label class="control-label col-form-label">{{'Scadenza.cliente' | translate}}</label>
                <ng-multiselect-dropdown [settings]="clientidropdownSettings" [placeholder]="'Scadenza.cliente' | translate" id="cliente" [data]="clienti"
                                         [(ngModel)]="clientiselezionati" (onFilterChange)="filtroCliente($event)" (ngModelChange)="filtroProdotti()" >
                </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="col-lg-4" *ngIf="prodotti?.length >0 && !environment.RmaAddOn['hideProdotto']">
            <label for="manager" class="control-label col-form-label">Prodotto</label>
            <ng-multiselect-dropdown [settings]="prodottidropdownSettings" [placeholder]="'Scadenza.prodotto' | translate" id="prodotto" [data]="prodotti"
                                     [(ngModel)]="prodottiselezionati" (onFilterChange)="filtroProdotti($event)" (ngModelChange)="refresh()">
            </ng-multiselect-dropdown>
          </div>
          <div class="col-lg-2" *ngIf="!environment.RmaAddOn['hideChiuso']">
            <div class="form-group">
              <label class="control-label col-form-label">Chiuso</label>
              <ng-multiselect-dropdown [settings]="closedDS" [placeholder]="'Chiuso' | translate" id="chiuso" [data]="[{id: true, label:'Chiuso'}, {id: false, label:'Non Chiuso'}]"
                                       [(ngModel)]="closedf" (ngModelChange)="refresh()" >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="col-lg-2">
            <div class="form-group">
              <label class="control-label col-form-label">Tipo</label>
              <ng-multiselect-dropdown [settings]="closedDS" [placeholder]="'Tipo' | translate" id="chiuso" [data]="tipi"
                                       [(ngModel)]="tipoObject" (ngModelChange)="refresh()" >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="col-lg-2" *ngIf="environment.RmaAddOn['statoFilter']">
            <div class="form-group">
              <label class="control-label col-form-label">Stato</label>
              <ng-multiselect-dropdown [settings]="closedDS" [placeholder]="'Tipo' | translate" id="chiuso" [data]="stati"
                                       [(ngModel)]="stato" (ngModelChange)="refresh()" >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="col-lg-2" *ngIf="environment.RmaAddOn['approvato']">
            <div class="form-group">
              <label class="control-label col-form-label">Approvato</label>
              <ng-multiselect-dropdown [settings]="closedDS" [placeholder]="'Approvato' | translate" id="chiuso" [data]="[{id: true, label:'Approvato'}, {id: false, label:'Non Approvato'}]"
                                       [(ngModel)]="Approvato" (ngModelChange)="refresh()" >
              </ng-multiselect-dropdown>
            </div>
          </div>
          <div class="col-lg-12">
            <app-field-viewer [(Campi)]="environment.RmaAddOn['filtersTaskboard']" [(Oggetto)]="filtro" (OnChange)="refresh()"></app-field-viewer>
          </div>
        </div>

      </div>
    </div>
    <div class="d-md-flex align-items-center bg-white">

      <app-stampa [Stampe]="Stampe" *ngIf="Stampe && Stampe.length > 0"></app-stampa>
      <div class=" mt-3 mb-3 mt-md-0" *ngIf="permission.HasCapacity(['gestione-attivita'])">
        <button class="btn btn-outline-primary" (click)="Edit()"> Aggiungi</button>
      </div>
      <span class="d-flex align-items-center p-2 ml-auto ">
        <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14"></h5>
        <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14">{{List?.length}}</span>
      </span>
    </div>
    <div class="table-responsive">
      <table class="table bg-white table-hover align-middle mb-0 no-wrap">
        <thead>
        <tr *ngIf="!(environment.RmaAddOn['headersTaskboard']?.length > 0)">
          <th>Alerts</th>
          <th scope="col" (click)="order({nome: 'id', oggetti:['id']})">Id</th>
          <th scope="col" (click)="order({nome: 'titolo', oggetti:['nome']})">Titolo</th>
          <th scope="col">{{'Scadenza.cliente' | translate}}</th>
          <th scope="col" (click)="order({nome: 'titolo', oggetti:['data_inizio_prevista'], inputType: 'datetime-local'})">Data di Segnalazione</th>
          <th scope="col" (click)="order({nome: 'titolo', oggetti:['data_fine_prevista'], inputType: 'datetime-local'})">Data di Scadenza</th>
          <th scope="col" (click)="order({nome: 'titolo', oggetti:['data_inizio_effettiva'], inputType: 'datetime-local'})">Data di Inizio</th>
          <th scope="col" (click)="order({nome: 'titolo', oggetti:['data_fine_effettiva'], inputType: 'datetime-local'})">Data di Fine</th>
          <th scope="col">Responsabile</th>
          <th scope="col">Azioni</th>
        </tr>
        <tr *ngIf="environment.RmaAddOn['headersTaskboard']?.length > 0 ">
          <ng-container *ngFor="let campo of environment.RmaAddOn['headersTaskboard']">
            <th scope="col" *ngIf="campoUtility.Show(campo, {},false)">{{campo.nome}}</th>
          </ng-container>
          <th scope="col">Azioni</th>
        </tr>
        </thead>
        <tbody *ngIf="environment.RmaAddOn['headersTaskboard']?.length > 0 ">
        <tr *ngFor="let item of List">
          <ng-container *ngFor="let campo of Header()">
            <td>
          <span  [ngClass]="{'badge badge-pill ': campoUtility.Colore(campo,item)!= undefined }" [ngStyle]="{'background-color': campoUtility.Colore(campo,item), 'font-size':'14px'} " >
            <ng-container *ngFor="let oggetto of campo.oggetti; let i = index">
              <ng-template [ngIf]="campo.type!= 'object' && campo.inputType == 'date' && item[oggetto]">
                {{campoUtility.getObj(item, oggetto) | date: 'dd/MM/yyyy'}} &nbsp;
              </ng-template>
              <ng-template
                [ngIf]="campo.type == 'object' && campo.inputType == 'date' && campoUtility.getObj(item, oggetto) ">
                {{campoUtility.getObj(item, oggetto)[campo.field[i]] | date: 'dd/MM/yyyy'}} &nbsp;
              </ng-template>
              <ng-template [ngIf]="campo.type!= 'object' && campo.inputType == 'datetime-local' && item[oggetto]">
                {{campoUtility.getObj(item, oggetto) | date: 'dd/MM/yyyy HH:mm'}} &nbsp;
              </ng-template>
              <ng-template
                [ngIf]="campo.type == 'object' && campo.inputType == 'datetime-local' && campoUtility.getObj(item, oggetto)">
                {{campoUtility.getObj(item, oggetto)[campo.field[i]] | date: 'dd/MM/yyyy HH:mm'}} &nbsp;
              </ng-template>
               <ng-template
                 [ngIf]="campo.type!= 'object' && campo.inputType != 'date' && campo.inputType != 'datetime-local'  && campo.type != 'replace' && campo.type != 'objArray'">
                {{campoUtility.getObj(item, oggetto)}} &nbsp;
              </ng-template>
              <ng-template
                [ngIf]="campo.type == 'object' && campo.inputType != 'date' && campo.inputType != 'datetime-local' && item[oggetto] && campoUtility.getObj(item, oggetto)">
                {{campoUtility.getObj(item, oggetto)[campo.field[i]]}} &nbsp;
              </ng-template>
              <ng-template
                [ngIf]="campo.type == 'object' && campo.inputType != 'date' && campo.inputType != 'datetime-local' && !item[oggetto] && campo.oggettisec && campo.oggettisec[i] && item[campo.oggettisec[i]]">
                {{item[campo.oggettisec[i]][campo.field[i]]}} &nbsp;
              </ng-template>
              <ng-template [ngIf]="campo.type == 'replace' ">
                {{campoUtility.Replace(campo, item, oggetto)}} &nbsp;
              </ng-template>
              <ng-template [ngIf]="campo.type == 'objArray' ">
                <ng-container *ngFor="let obg of campoUtility.getObj(item, oggetto)">
                  {{obg[campo.field[i]]}} &nbsp;
                </ng-container>
              </ng-template>
           </ng-container>
          </span>
            </td>
          </ng-container>

          <td class="align-middle">
            <a *ngIf="permission.HasCapacity(['gestione-attivita'])" href="javascript:void(0)" ngbTooltip="Modifica"
               class="link font-16 text-info font-medium mr-2" (click)='Edit(item)'>
              <i-feather name="edit-3" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="permission.HasCapacity(['gestione-attivita'])" href="javascript:void(0)" ngbTooltip="Elimina"
               class="link font-16 text-danger font-weight-bold"
               (click)='Delete(item)'>
              <i-feather name="trash-2" class="feather-sm"></i-feather>
            </a>
          </td>
        </tr>
        </tbody>
        <tbody *ngIf="!(environment.RmaAddOn['headersTaskboard']?.length > 0)">
        <tr *ngFor="let item of List ">
          <td>
            <a *ngIf="Warning(item) != ''" href="javascript:void(0)"
               [ngbTooltip]="'Sono presenti Attivita in sospeso:\n'+Warning(item)"
               class="link font-16 text-danger font-weight-bold">
              <i class="fas fa-exclamation-triangle text-warning"></i>
            </a>
            <a *ngIf="WarningNoResp(item) != ''" href="javascript:void(0)"
               [ngbTooltip]="'Sono presenti Attivita non Assegnate:         \n'+WarningNoResp(item)"
               class="link font-16 text-danger font-weight-bold">
              <i class="fas fa-exclamation-circle text-warning"></i>
            </a>
            <a *ngIf="tag(item) != ''" href="javascript:void(0)"
               [ngbTooltip]="'Sei stato/a taggato nelle seguenti Attivita:         \n'+tag(item)"
               class="link font-16 text-danger font-weight-bold">
              <i class="fas fa-exclamation-circle text-info"></i>
            </a>
          </td>
          <td (click)='Edit(item)'>
          
            <span class="badge badge-pill px-3   font-14">
              {{item?.id}}</span>
          </td>
          <td (click)='Edit(item)'>

        <span class="badge badge-pill px-3   font-14">
          {{item?.nome}}</span>
          </td>
          <td (click)='Edit(item)'>

            <span class="badge badge-pill px-3   font-14">
              {{item?.clienteObject?.nominativo ?? ''}}</span>
          </td>
          <td (click)='Edit(item)'>
        <span class="badge badge-pill px-3   font-14">
          {{item?.data_inizio_prevista | date: 'dd/MM/yyyy HH:mm'}}</span>
          </td>
          <td (click)='Edit(item)'>
        <span class="badge badge-pill px-3   font-14">
          {{item?.data_fine_prevista | date: 'dd/MM/yyyy HH:mm'}}</span>
          </td>
          <td (click)='Edit(item)'>
        <span class="badge badge-pill px-3   font-14">
          {{item?.data_inizio_effettiva | date: 'dd/MM/yyyy HH:mm'}}</span>
          </td>
          <td (click)='Edit(item)'>
        <span class="badge badge-pill px-3   font-14">
          {{item?.data_fine_effettiva | date: 'dd/MM/yyyy HH:mm'}}</span>
          </td>
          <td (click)='Edit(item)'>
        <span class="badge badge-pill px-3   font-14">
          {{item?.managerObject?.fullName }}</span>
          </td>
          <td class="align-middle">
            <a *ngIf="permission.HasCapacity(['gestione-attivita'])" href="javascript:void(0)" ngbTooltip="Modifica"
               class="link font-16 text-info font-medium mr-2" (click)='Edit(item)'>
              <i-feather name="edit-3" class="feather-sm"></i-feather>
            </a>
            <a *ngIf="permission.HasCapacity(['gestione-attivita'])" href="javascript:void(0)" ngbTooltip="Elimina"
               class="link font-16 text-danger font-weight-bold"
               (click)='Delete(item)'>
              <i-feather name="trash-2" class="feather-sm"></i-feather>
            </a>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>


